import React, { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqItems = [
    {
      question: "Is this a real ticket?",
      answer: "No, this is a dummy/sample ticket. It contains real flight information but is not a verifiable booking. It does not contain a valid PNR (Passenger Name Record) and cannot be used to board a flight. The responsibility for its usage lies solely with you."
    },
    {
      question: "What can I use this ticket for?",
      answer: "This is a sample ticket that may be used for documentation purposes where proof of flight reservation is needed. However, it is NOT a real booking and is NOT valid for travel. Always verify specific requirements with the relevant authorities for your particular situation."
    },
    {
      question: "How quickly will I receive my ticket?",
      answer: "Your PDF ticket is delivered via email instantly, usually within 30 seconds of generation. If you don't receive it, check your spam/junk folder."
    },
    {
      question: "Can I use this for multiple passengers?",
      answer: "Yes! You can add multiple passenger names to a single ticket. When generating your ticket, you'll have the option to add additional passengers (up to 5 extra passengers on paid tickets). This is perfect for families or groups traveling together."
    },
    {
      question: "What information do I need to provide?",
      answer: "You need to provide: your first name, last name, email address, and select a flight from the search results. That's it! The ticket will be generated with your name and the selected flight details."
    },
    {
      question: "Is my personal information secure?",
      answer: "Yes, we take your privacy seriously. Your information is only used to generate your ticket and send it to your email. We do not share your data with third parties. See our Privacy Policy for more details."
    }
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-8">
          <h3 className="text-center mb-4">Frequently Asked Questions</h3>
          <div className="accordion" id="faqAccordion">
            {faqItems.map((item, index) => (
              <div key={index} className="accordion-item">
                <h2 className="accordion-header" id={`heading${index}`}>
                  <button
                    className={`accordion-button ${openIndex === index ? '' : 'collapsed'}`}
                    type="button"
                    onClick={() => toggleFaq(index)}
                    aria-expanded={openIndex === index}
                    aria-controls={`collapse${index}`}
                  >
                    {item.question}
                  </button>
                </h2>
                <div
                  id={`collapse${index}`}
                  className={`accordion-collapse collapse ${openIndex === index ? 'show' : ''}`}
                  aria-labelledby={`heading${index}`}
                >
                  <div className="accordion-body">
                    {item.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;

